import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=76dfd05a&scoped=true&lang=pug"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&id=76dfd05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dfd05a",
  null
  
)

export default component.exports